import { createSlice } from "@reduxjs/toolkit"

const initialSystemState = { 
    theme: 'light',
    systemAlerts: null,
    /** Bumped when system settings in localStorage are refreshed (API sync / socket). */
    settingsRevision: 0,
}

const systemSlice = createSlice({
    name: 'system',
    initialState: initialSystemState,    
    reducers: {
        setTheme(state, data) {
            state.theme = data.payload
        },
        setSystemAlerts(state, data) {
            state.systemAlerts = data.payload
        },
        removeAlert(state, data) {
            const index = state.systemAlerts.findIndex(object => {
                return object.id == data.payload
            })

            if (index !== -1) {
                state.systemAlerts.splice(index, 1)
            }
        },
        bumpSettingsRevision(state) {
            state.settingsRevision += 1
        },
    }
})

export const systemActions = systemSlice.actions

export default systemSlice.reducer